module.exports = __webpack_public_path__ + "static/media/service-time-icon.7dcad054.png";